



















import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import PaymentSidebar from './components/PaymentSidebar.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { User } from '@/classes/User'
import Api from '@/api'
import Header from '@/views/app/admin/components/Header.vue'
import Card from '@/components/Card.vue'
import Icon from '@/components/Icon.vue'
import GoBack from '@/components/GoBack.vue'

@Component({
  components: {
    GoBack,
    Icon,
    Card,
    Header,
    PaymentSidebar
  }
})
export default class ManagementPayment extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User

  get residentId () {
    return this.$route.params.residentId
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get defaultRoute () {
    return !this.user.isResident()
      ? { name: 'management-resident', params: { id: this.residentId } }
      : { name: 'resident-general' }
  }

  async mounted () {
   this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    await Promise.all([
      this.residentModuleInstance.getResidentPaymentMethods(this.residentId),
      this.residentModuleInstance.fetchResidentById(this.residentId),
      this.residentModuleInstance.fetchResidentContacts(this.residentId)
    ])
    setTimeout(() => this.$eventBus.$emit('loading:disable'), 300)
  }

  beforeDestroy () {
    this.residentModuleInstance.resetResidentInfo()
    this.residentModuleInstance.resetSelectedResident()
  }
}
